import React from 'react';

const ActiveBackX = () => (
  <svg
    width="176"
    height="173"
    viewBox="0 0 176 173"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute bottom-0 right-0 z-0"
  >
    <path
      d="M221.127 0.796875H180.943C179.401 0.796875 177.908 1.58397 176.968 2.87705L128.757 68.8805L151.619 107.378L224.401 7.81044C226.575 4.78856 224.717 0.796875 221.127 0.796875Z"
      fill="#0059CC"
    />
    <path
      d="M148.95 120.07L119.836 158.299L143.776 200.842C144.512 202.142 145.886 202.936 147.428 202.936H187.127C190.716 202.936 193.191 198.966 191.494 195.937L148.95 120.07Z"
      fill="#0059CC"
    />
    <path
      d="M44.4011 221.067H4.21747C0.621125 221.067 -1.23666 217.075 0.95059 214.053L76.2494 111.613C77.329 110.116 77.4833 108.19 76.642 106.693L32.6236 28.2026C30.9271 25.1737 33.4018 21.2031 36.9911 21.2031H76.6911C78.2334 21.2031 79.6144 21.9902 80.3435 23.2973L127.418 106.953C128.26 108.457 128.112 110.376 127.033 111.88L48.376 218.986C47.4366 220.28 45.9434 221.067 44.4011 221.067Z"
      fill="#0059CC"
    />
  </svg>
);

export default ActiveBackX;
